import React from "react";
import { Image as ImageIcon } from "lucide-react";

/**
 * Reserved gray placeholder block — clearly labeled so real screenshots
 * can be dropped in later. Not a broken image, not stock art.
 */
export const Placeholder = ({
  label,
  aspect = "4/3",
  variant = "default",
  className = "",
  icon: Icon = ImageIcon,
  testId,
}) => {
  const isPhone = variant === "phone";

  return (
    <div
      data-testid={testId}
      role="img"
      aria-label={label}
      className={`relative w-full overflow-hidden ${className}`}
      style={{
        aspectRatio: aspect,
        background:
          "repeating-linear-gradient(45deg, #d9d4cc 0 12px, #d2cdc4 12px 24px)",
        border: "1px solid rgba(122, 116, 108, 0.25)",
        borderRadius: isPhone ? "26px" : "12px",
      }}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
        <div
          className="flex items-center justify-center mb-3 rounded-full"
          style={{
            width: 44,
            height: 44,
            background: "rgba(255,255,255,0.7)",
            color: "#7a746c",
            border: "1px solid rgba(122,116,108,0.2)",
          }}
        >
          <Icon size={20} strokeWidth={1.6} />
        </div>
        <p
          className="text-xs md:text-sm font-medium tracking-wide"
          style={{ color: "#5e5852" }}
        >
          [Screenshot]
        </p>
        <p
          className="text-xs md:text-sm mt-1 max-w-[260px] leading-snug"
          style={{ color: "#7a746c" }}
        >
          {label}
        </p>
      </div>
    </div>
  );
};

export default Placeholder;
